module.exports = __webpack_public_path__ + "static/media/img13.0905a654.jpg";